module.exports = __webpack_public_path__ + "static/media/slide-2.a8c62995.png";